module.exports = __webpack_public_path__ + "static/media/roche-logo-m.03ccf456.svg";